export const customHeaders = {
    "Content-Type": "application/json",
};
